import React, { useRef, useState } from "react";
import styled from "styled-components";
import PubSub from "pubsub-js";
import {
  _localizeText,
  _localizeField,
  // _allAddClass,
  _allRemoveClass
} from "../../core/utils";

const Label = styled.div`
  // margin-right: 1em;
  display: flex;
  &::after {
    content: ":";
    display: block;
    margin: 0 0.7em;
  }
`;
const Li = styled.li`
  display: flex;
  &::after {
    content: "|";
    display: block;
    margin: 0 0.7em;
  }
  &:last-child::after {
    display: none;
  }
  .is-active {
    text-decoration: underline;
  }
`;

const Variations = ({ input }) => {
  const variationsRef = useRef();
  const [showReset, setShowReset] = useState();

  const variationChange = (target, el) => {
    // console.log(target);
    _allRemoveClass(variationsRef.current, ".variation", "is-active");
    PubSub.publish("VARIATION_CHANGE", el);
    target.classList.add("is-active");
    setShowReset(true);
  };
  const variationReset = el => {
    _allRemoveClass(variationsRef.current, ".variation", "is-active");
    PubSub.publish("VARIATION_RESET");
    setShowReset(false);
  };

  return (
    <div className='variations x xjc ttu mbS' ref={variationsRef}>
      <Label>{_localizeText(input.label)}</Label>
      <ul className='x'>
        {input.variations.map((el, i) => (
          <Li key={i}>
            <button
              className='variation'
              onClick={e => variationChange(e.target, el)}>
              {_localizeField(el.title)}
            </button>
          </Li>
        ))}
        {showReset && (
          <Li>
            <button onClick={variationReset}>×</button>
          </Li>
        )}
      </ul>
    </div>
  );
};

export default Variations;
